import Login from '@src/main/ui/components/Login/Login';
import { type FC } from 'react';

const LoginPage: FC = () => <Login />;

export default LoginPage;
